import { FormControl, RadioGroup } from '@mui/material';

import { IEvaluacion } from '../constants';
import Divider from '../../Divider';
import FControlLabel from '../../shared/Forms/FControlLabel';


interface Props {
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
}

const TiempoEntrenamiento = ({ dataEvaluacion, handleChange } : Props) => {

  return (
    <div>
      <div className='text-center'>
        <h2 className="title font-bold mb-2">
          ¿Cuántos tiempo entrenaras al día?
        </h2>
        <p className="text-slate-500">Seleccione la cantidad de tiempo que entrenarás cada día</p>
        <Divider type="option" />
      </div>
      <div className="row">
        <div className="col-12" style={{ textAlign: 'left' }}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={dataEvaluacion.tiempoEntrenamiento}
              onChange={(ev) => handleChange('tiempoEntrenamiento', ev.target.value)}
            >
              <FControlLabel value={'C'} label="30 a 40 min" size='1.15rem' fontWeight={500} />
              <FControlLabel value={'M'} label="40 a 60 min" size='1.15rem' fontWeight={500} />
              <FControlLabel value={'L'} label="60 min a más" size='1.15rem' fontWeight={500} />
              
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  )
}

export default TiempoEntrenamiento;